import { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";
import {
  buildGtagUserDataFromStagedFreePass,
  hasFreePassThankYouGtagFired,
  markFreePassThankYouGtagFired,
} from "@/lib/googleAdsFreePassEnhanced";

export default function ThankYouGuestPassPage() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (hasFreePassThankYouGtagFired()) return;

    window.dataLayer = window.dataLayer || [];

    const userData = buildGtagUserDataFromStagedFreePass();

    if (userData) {
      window.dataLayer.push({ user_data: userData });
    }
    markFreePassThankYouGtagFired();
  }, []);

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center px-4" data-testid="thank-you-guest-pass">
      <SEO
        title="Thank You | Guest Pass Request"
        description="Your guest pass request has been received. A Giant Fitness team member will contact you shortly."
        url="/thank-you-3-day-guest-pass"
        noindex
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        <h1 className="text-3xl font-heading font-bold text-gray-900 mb-4">THANK YOU</h1>
        <p className="text-gray-600 mb-8">
          Thanks for your interest in a free guest pass. A team member will contact you shortly to get you set up.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/memberships">
            <Button className="w-full sm:w-auto bg-brand-orange hover:bg-brand-orange-hover text-white font-bold uppercase tracking-wider">
              View Memberships
            </Button>
          </Link>
          <Link to="/locations">
            <Button variant="outline" className="w-full sm:w-auto border-gray-300 text-gray-700 hover:bg-gray-50">
              Find a Location
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
